<template>
  <v-layout
    class="interaction-topper worksheet-interaction-topper px-2 grey--text text--darken-3"
    align-center
    justify-start
  >
    <span
      tabindex="0"
      :aria-label="interactionNumberAriaLabel"
    >
      #{{interactionNumber}}
    </span>
    <div class="px-2 font-weight-bold">|</div>
    <span
      tabindex="0"
      :aria-label="timestampAriaLabel"
    >
      {{generateInteractionTimestamp(interaction)}}
    </span>
    <div class="px-2 font-weight-bold">|</div>
    <span
      tabindex="0"
      :aria-label="pointsAriaLabel"
    >
      <template v-if="(
        localInteractionAttempt
        && typeof localInteractionAttempt.pointsEarned === 'number'
      )">
        {{localInteractionAttempt.pointsEarned}}/{{localInteractionAttempt.pointsAvailable}} point{{localInteractionAttempt.pointsAvailable !== 1 ? 's' : ''}}
      </template>
      <template v-else>
        __ / {{localInteraction.pointsAvailable}} point{{localInteraction.pointsAvailable !== 1 ? 's' : ''}}
      </template>
    </span>
    <template v-if="showWorksheetInteractionType">
      <div class="px-2 font-weight-bold">|</div>
      <span
        tabindex="0"
        :aria-label="`For interaction #${interactionNumber}, check all poll options that apply.`"
      >
        Check all that apply
      </span>
    </template>
    <template
      v-if="(
        bank
        && bank.type === 'random'
      )"
    >
      <div class="px-2 font-weight-bold">|</div>
      <v-icon
        :size="14"
        tabindex="0"
        :aria-label="`Interaction #${interactionNumber} is part of a random question bank and there may be more interactions than are currently shown.`"
      >
        batch_prediction
      </v-icon>
    </template>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import Interaction from '../../mixins/Interaction';
import {
  interactionTypeData,
} from '../../constants';

export default {
  name: 'WorksheetTopper',
  mixins: [
    Interaction,
  ],
  props: {
    interactionAttempt: {
      type: Object,
      required: false,
    },
    perspectiveKey: {
      type: String,
      required: true,
    },
    interactionBodyComponentKey: {
      type: String,
      required: true,
    },
    interactionNumber: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    interactionTypeData() {
      return interactionTypeData;
    },
    showWorksheetInteractionType() {
      return (
        this.localInteraction.interactionType === 'check_all_apply'
        || (
          this.localInteraction.interactionType === 'poll_q'
          && this.localInteraction.isMultiselect
        )
      );
    },
    timestampAriaLabel() {
      let label = `Interaction #${this.interactionNumber} timestamp: `;
      if (
        _.isNil(this.localInteraction.displayOutTime)
        || this.localInteraction.displayInTime === this.localInteraction.displayOutTime
      ) {
        label += `${this.localInteraction.displayInTime.humanizeTimestamp()}`;
      } else {
        label += `${this.localInteraction.displayInTime.humanizeTimestamp()} to ${this.localInteraction.displayOutTime.humanizeTimestamp()}`;
      }
      return label;
    },
    pointsAriaLabel() {
      const availablePoints = this.localInteractionAttempt ? this.localInteractionAttempt.pointsAvailable : this.localInteraction.pointsAvailable;
      let label = `Interaction #${this.interactionNumber} is worth ${availablePoints} point${availablePoints === 1 ? '' : 's'}. `;
      if (
        this.localInteractionAttempt
        && _.isNil(this.localInteractionAttempt.pointsEarned)
      ) {
        label += 'Your attempt at this interaction is still being graded at this time.';
      } else if (this.localInteractionAttempt) {
        label += `Your attempt at this interaction earned ${this.localInteractionAttempt.pointsEarned} point${this.localInteractionAttempt.pointsEarned === 1 ? '' : 's'}.`;
      }
      return label.trim();
    },
    interactionNumberAriaLabel() {
      return `Interaction #${this.interactionNumber}: ${this.interactionTypeData[this.localInteraction.interactionType].label}`
    },
  },
  methods: {
    generateInteractionTimestamp(interaction) {
      if (
        !_.isFinite(interaction.displayOutTime)
        || interaction.displayOutTime === interaction.displayInTime
      ) {
        return this.$convertTimestamp(interaction.displayInTime);
      }
      return `${this.$convertTimestamp(interaction.displayInTime)} - ${this.$convertTimestamp(interaction.displayOutTime)}`;
    },
  },
};
</script>
